import { atom } from 'recoil';
import { IUserSettings } from '../selectors/permissionsSelector';

type TPrimitive = number | boolean | string | null;

export enum Role {
  /* eslint-disable-next-line no-unused-vars */
  SUPERADMIN = 'superadmin',
  /* eslint-disable-next-line no-unused-vars */
  ADMIN = 'admin',
  /* eslint-disable-next-line no-unused-vars */
  MANAGER = 'manager',
  /* eslint-disable-next-line no-unused-vars */
  USER = 'user',
}

export const RoleLevel = {
  /* eslint-disable-next-line no-unused-vars */
  [Role.SUPERADMIN]: 0,
  /* eslint-disable-next-line no-unused-vars */
  [Role.ADMIN]: 10,
  /* eslint-disable-next-line no-unused-vars */
  [Role.MANAGER]: 20,
  /* eslint-disable-next-line no-unused-vars */
  [Role.USER]: 30,
};

export interface IBusinessModel {
  CallRecord: number;
  FSaccountid: string;
  FollowUpSMSActive: number;
  LocalPresenceType: string;
  PlivoAuth: string | null;
  SMSactive: number;
  SubscriptionSMSActive: number;
  accountManagerEmail: string | null;
  address1: string;
  allowAgentPowerlist: number;
  apikey?: string;
  apiKey: string;
  apikeyenabled: number;
  autoAnswerApi: number;
  balanceupdated: string;
  billDay: number;
  blockOutboundCallRecordingSetting: string;
  blocked: TPrimitive;
  businessBillingTerm: number;
  businessContractTerm: string;
  businessURL: string;
  businesscountrycode: string;
  businessid: number;
  canDeleteUsers: number;
  category: string;
  city: string;
  clientid: number;
  connectionDuration: number;
  createContact: number;
  created: string | null;
  cred: string;
  crmID: string | null;
  dealClosedBy?: number | string | null;
  dealClosedDateTime?: string | null;
  directSync: number;
  discountPercent: number;
  discountEndDate: string;
  email: string;
  emailHash: string;
  emailVerified: number;
  env: string;
  externalid: TPrimitive;
  frequency: string;
  fromGMT: number;
  hasCRM: number;
  hasSlack: number;
  hasWebhook: number;
  hashCT: string | null;
  holdMusic: string | null;
  inboundRingtone: string | null;
  invoicedUntil: string;
  isactive: number;
  lastcallid: string;
  lastcharge: string;
  lastdataupdate: string;
  lastinvoicedate: string | null;
  lastrechargeinvoice: string;
  leaderboardSort: string;
  logPowercallAttemptsToCrm: number;
  maxrate: number;
  minimumBalance: number;
  minutesBalance: number;
  name: string;
  onlyManagersCanAddPhoneNumbers: number;
  onlyManagersCanViewCallReporting: number;
  plivoRegion: string;
  plivoToken: string;
  plivoacctid: string;
  prepaidTrial: number;
  publicKey: string;
  rechargeAmount: number;
  recordingRetention: number;
  reserveBalance: number;
  salesRepEmail: string;
  salescycle: number;
  salescycletype: string;
  sendRecordingToCRM: number;
  setupRepEmail: string | null;
  sipRealm: string;
  sipUser: string;
  state: string;
  terminatingnumber: TPrimitive;
  // eslint-disable-next-line camelcase
  timezone_php: string;
  timezoneid: number;
  userTier: string;
  webhookDelay: number;
  website: string;
  defaultCrmUserid: string;
  DncBlocksOutboundSMS: number;
  stopBlocksOutboundCalls: number;
  usagePlanProduct?: string;
  showOutcomeForAllAgents?: number;
  requireOutcomeForAllAgents?: number;
  AssignedCAM?: string | null;
  assignedCAMname?: string | null;
  machineDetectionTime?: number | null;
  allowPauseRecording?: number | null;
}

export interface IBusinessUser {
  DND: number;
  agentQueueEnabled: 0 | 1;
  allowMultipleIncomingCalls: number;
  callerid: string;
  calleridName: string;
  canBeManaged: 0 | 1;
  canCallCoach: 0 | 1;
  chromeVersion: string | null;
  closedAction: string | null;
  countrycode: string;
  created: string;
  crmname: string;
  deviceType: string;
  domain: null;
  email: string;
  fname: string;
  ftcBlocking: 0 | 1;
  greeting: string | null;
  inactiveDate: string;
  isactive: 0 | 1;
  lname: string;
  logLevel:
    | 'off'
    | 'fatal'
    | 'error'
    | 'warn'
    | 'info'
    | 'debug'
    | 'trace'
    | 'all';
  localPresenceLite: 0 | 1;
  localPresenceOn: 0 | 1;
  othersCanViewRecordings: 0 | 1;
  setSuperadminPermissions: 0 | 1;
  switchUser: 0 | 1;
  overrideDnc: 0 | 1;
  phoneType: string;
  platform: null;
  recordCalls: 0 | 1;
  smsDID: string | null;
  teams: null;
  type: 'user' | 'manager' | 'admin' | 'superadmin' | null;
  useBusinessHoursEnabled: 0 | 1;
  userEXT: number;
  userHours: null;
  userTier: string;
  userid: number;
  version: null;
  vmDropDetectionType: string;
  systemTeamId?: string;
  defaultExtend?: 0 | 1;
  powerlistProductId: number | null;
  powerlistDisplayName: string | null;
  powerlistEndDate: string | null;
  nextPowerlistProductId: string | null;
  nextPowerlistDisplayName: string | null;
  nextPowerlistStartDate: string | null;
  hasPdCallTranscription: 0 | 1 | null;
  userTierDisplayName: string | null;
  nextUserTier: string | null;
  nextUserTierDisplayName: string | null;
  nextUserTierStartDate: string | null;
  canPauseRecording: number | null;
}

export interface IUserModel {
  userid: number;
  email: string;
  callerid: string;
  calleridName: string;
  countrycode: string;
  crmid: string | null;
  deviceid: string;
  extension: number;
  fname: string;
  hasCRM: boolean;
  lname: string;
  role: Role;
  smsDID: string | null;
  tier: string;
  isactive: number;
  created: string | null;
  userTier: string;
  crmname: string;
  setSuperadminPermissions: 0 | 1;
  systemTeamId: number;
}

export interface IUserAtom {
  apikey: string;
  accessToken?: string;
  billingStatus: {
    amount: number;
    blocked: TPrimitive;
    cardDeclined: number;
    days: number;
    expiringNoBilling: number;
    hasBilling: number;
    hasCredit: number;
    inTrial: number;
    isactive: number;
    maxrate: number;
    minutes: number;
    trialExpired: number;
  };
  business: IBusinessModel;
  businessid: number;
  crmid: TPrimitive;
  deviceid: string;
  expiresIn: number;
  hasCRM: boolean;
  permissions: {
    canCallCoach: number;
    sendSMS: number;
  };
  refreshToken: string;
  settings: {
    DIDGreeting: string | null;
    LightModeon: number;
    canBeManaged: string;
    cellNumber: string | number;
    cellNumberCC: string | number;
    hasCell: number;
    localpresence: number;
    mediaMetricsOn: number;
    othersCanViewRecordings: string;
    playEndSound: number;
    playStartSound: number;
    recordCalls: number;
    screenPop: number;
    sendRecordingtoCRM: number;
    useCellService: number;
    vmDropDetectionType: string;
  };
  sip: {
    pass: string;
    user: string;
  };
  tier: string;
  user: IUserModel;
  userid: number;
  selectedPowerlistId?: string;
  brandStatus10Dlc?: {
    brandStatus?: string;
    businessNumbersCount?: number;
  };
  onboardingWalkthrough?: {
    businessHours?: string;
    displayOnboarding?: boolean;
    owWizardData?: string | null;
  };
  userSettings: IUserSettings & {
    accessToken: string;
    expiresInTimestamp: number;
  };
  terms: {
    acceptedAt: string | null;
    acceptedIp: string | null;
    versionAccepted: string | null;
  };
}

// eslint-disable-next-line @typescript-eslint/ban-types
export const user = atom<IUserAtom | {}>({
  key: 'user',
  default: {
    // empty means pending, null means unauthorized, populated means authenticated
  },
});
